import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'TicketKind',
    column_type: 'id',
  },
  created_at: {
    model_name: 'TicketKind',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'TicketKind',
    column_type: 'datetime',
  },
  ticket_event: {
    model_name: 'TicketKind',
    column_type: 'belongs_to',
    extra: {
      association_name: 'ticket_event',
      model_name: 'TicketEvent',
      foreign_key: 'ticket_event_id',
    },
  },
  ticket_event_id: {
    model_name: 'TicketKind',
    column_type: 'belongs_to',
    extra: {
      association_name: 'ticket_event',
      model_name: 'TicketEvent',
      foreign_key: 'ticket_event_id',
    },
  },
  title: {
    model_name: 'TicketKind',
    column_type: 'string',
  },
  capacity: {
    model_name: 'TicketKind',
    column_type: 'integer',
  },
  price_cents: {
    model_name: 'TicketKind',
    column_type: 'integer',
  },
  description: {
    model_name: 'TicketKind',
    column_type: 'string',
  },
  activity_time_kind: {
    model_name: 'TicketKind',
    column_type: 'enum',
  },
  start_day_of_week: {
    model_name: 'TicketKind',
    column_type: 'integer',
  },
  end_day_of_week: {
    model_name: 'TicketKind',
    column_type: 'integer',
  },
  start_date: {
    model_name: 'TicketKind',
    column_type: 'date',
  },
  end_date: {
    model_name: 'TicketKind',
    column_type: 'date',
  },
  expiration_kind: {
    model_name: 'TicketKind',
    column_type: 'enum',
  },
  expire_at: {
    model_name: 'TicketKind',
    column_type: 'datetime',
  },
  sold_capacity: {
    model_name: 'TicketKind',
    column_type: 'string',
  },
  sold_amount: {
    model_name: 'TicketKind',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
